import { useState, useEffect } from 'react';

function useDebouncedValue(value, delay) {
	const [debouncedValue, setDebouncedValue] = useState(value);

	useEffect(() => {
		// Set a timeout to update the debounced value
		const handler = setTimeout(() => {
			setDebouncedValue(value);
		}, delay);

		// Clear timeout if value or delay changes, or on cleanup
		return () => {
			clearTimeout(handler);
		};
	}, [value, delay]);

	return debouncedValue;
}

export default useDebouncedValue;
